<template>
    <MainContentSearchable title="Listado de códigos de invitación" id="codigos_invitacion" v-model="filters" :meta="loading ? {} : codigos_invitacion.meta" @updated="getCodigosInvitacion">
        <template v-slot:header>
            <div class="ml-auto">
                <button @click="showModal('crear-codigos')" class="btn btn-primary mb-3">Generar códigos</button>
                <CrearCodigos @terminado="getCodigosInvitacion"/>
            </div>
        </template>
        <template v-slot:content>
            <div v-if="codigos_invitacion" :class="['table', { 'expanded': codigos_invitacion.data.length <= 3 }]">
                <b-table hover :items="codigos_invitacion.data" :fields="fields" id="codigos_invitacion-table">
                    <template #cell(opciones)="{ item, index }">
                        <OpcionesDropdownTableComponent 
                            :lastIndex="codigos_invitacion.data.length > 3 && index >= codigos_invitacion.data.length - 3"
                            v-bind:options="[
                                { type: 'action', action:() => showModal('borrar-' + item.id), label: 'Borrar'},
                                { type: 'action', action:() => showModal('editar-' + item.id), label: 'Editar'}
                            ]"
                        />
                        <EditarCodigo :codigo="item" v-on:close="closeModal" @terminar="editarCodigo"/>
                        <BorrarCodigo :codigo="item" v-on:close="closeModal" @terminado="getCodigosInvitacion"/>
                    </template>
                </b-table>
            </div>
        </template>
    </MainContentSearchable>
</template>

<script>
    import MainContentSearchable from '@/components/backend/components/MainContentSearchable';
    import OpcionesDropdownTableComponent from "@/components/backend/components/OpcionesDropdownTableComponent";
    import CrearCodigos from './modals/CrearCodigos';
    import EditarCodigo from './modals/EditarCodigo';
    import BorrarCodigo from './modals/BorrarCodigo';

    export default {
        props: ['lista_id', 'categoria_id'],
        data() {
            return {
                codigos_invitacion: {},
                loading: false,
                filters: {
                    per_page: 10,
                    page: 1,
                    search: ''
                },
                fields: [
                    { key: "id", label: "ID", class: 'text-center'},
                    { key: "codigo", label: "Código", class: 'text-center' },
                    { key: "usos", label: "Usos", class: 'text-center' },
                    { key: "opciones", label: "Opciones", class: 'text-center' }
                ],
            }
        },
        created() {
            this.getCodigosInvitacion();
        },
        methods: {
            getCodigosInvitacion() {
                this.loading = true;

                let params = {
                    lista_id: this.lista_id,
                    categoria_id: this.$route.params.categoria_id,
                    filters: this.filters
                };
                this.$store.dispatch(this.config.getVuexAlias('back.bases.categorias.codigos_invitacion.index'), params).then(res => {
                    this.codigos_invitacion = res.data;
                    this.$emit('creado');
                }).finally(() => this.loading = false);
            },
            editarCodigo(usos, codigo_id) {
                this.loading = true;

                let params = {
                    lista_id: this.lista_id,
                    categoria_id: this.$route.params.categoria_id,
                    codigo_id: codigo_id,
                    usos: usos,
                    filters: this.filters
                };
                this.$store.dispatch(this.config.getVuexAlias('back.bases.categorias.codigos_invitacion.editar'), params).then(res => {
                    this.$toast.success(res.data.message);
                    this.closeModal('editar-' + codigo_id, true);
                }).finally(() => this.loading = false);
            },
            showModal(modal) {
                this.$modal.show(modal);
            },
            closeModal(modal, borrado) {
                this.$modal.hide(modal);
                if(borrado) {
                    this.getCodigosInvitacion();
                }
            },
        },
        components: {
            MainContentSearchable, OpcionesDropdownTableComponent, CrearCodigos, EditarCodigo, BorrarCodigo
        }
    }
</script>
<style scoped>
.table {
    overflow: auto;
}

.table.expanded {
    padding-bottom: 150px !important;
}
</style>